const questionsData = [
    {
        questionId: 1,
        group: 'Moving to HANA and Cloud',
        question: 'Using SAP ECC today, where is your organisation running SAP ERP?',
        dimension: 'Using SAP ECC today, where is your organisation running SAP ERP?',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
    },
    {
        questionId: 2,
        group: 'Moving to HANA and Cloud',
        question: 'Using SAP S4/HANA today, where is your organisation running SAP S4/HANA?',
        dimension: 'Using SAP S4/HANA today, where is your organisation running SAP S4/HANA?',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
    },

    {
        questionId: 3,
        group: 'Moving to HANA and Cloud',
        question: 'How much of your organisation’s SAP data is currently held in the cloud?',
        dimension: 'How much of your organisation’s SAP data is currently held in the cloud?',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },
    {
        questionId: 4,
        group: 'Moving to HANA and Cloud',
        question: 'Does your organisation plan to store all its SAP data in cloud?',
        dimension: 'Does your organisation plan to store all its SAP data in cloud?',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
    },
    {
        questionId: 5,
        group: 'Moving to HANA and Cloud',
        question: 'What data management infrastructure is your organisation currently using to analyse its SAP data?',
        dimension: 'What data management infrastructure is your organisation currently using to analyse its SAP data?',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
    },
    {
        questionId: 6,
        group: 'Moving to HANA and Cloud',
        question: "How beneficial do you think the move to HANA has been/will be for your organisation's ability to utilise its SAP data?",
        dimension: "How beneficial do you think the move to HANA has been/will be for your organisation's ability to utilise its SAP data?",
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
    },
    {
        questionId: 7,
        group: 'Moving to HANA and Cloud',
        question: 'Overall, how concerned, if at all, is/was your organisation about the move to SAP HANA?',
        dimension: 'Overall, how concerned, if at all, is/was your organisation about the move to SAP HANA?',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },
    {
        questionId: 8,
        group: 'Moving to HANA and Cloud',
        question: 'Concern or previous concern with moving to SAP HANA',
        dimensionStack: 'Concerns',
        dimension: 'Concerns Answer',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'stacked',
    },
    {
        questionId: 9,
        group: 'Moving to HANA and Cloud',
        question: 'The forced migration to SAP HANA has been a hinderance to my organisation',
        dimension: 'The forced migration to SAP HANA has been a hinderance to my organisation',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
    },
    {
        questionId: 10,
        group: 'Unlocking SAP data for Analytics',
        question: 'Benefit did/would your organisation expect to gain from replicating its SAP data into the cloud for analytics',
        dimensionStack: 'Benefits',
        dimension: 'Benefits Answer',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'stacked',
    },
    {
        questionId: 11,
        group: 'Unlocking SAP data for Analytics',
        question: 'How do you think replicating SAP data into the cloud for analytics has impacted/will impact the following area at your organisation?',
        dimensionStack: 'Impact',
        dimension: 'Impact Answer',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'stacked',
    },
    {
        questionId: 12,
        group: 'Unlocking SAP data for Analytics',
        question: 'If you are analysing  your SAP data from a data warehouse or data lake, what is the current latency for your SAP data?',
        dimension: 'If you are analysing  your SAP data from a data warehouse or data lake, what is the current latency for your SAP data?',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },
    {
        questionId: 13,
        group: 'Unlocking SAP data for Analytics',
        question: 'If you are analysing  your SAP data from a data warehouse or data lake, what is the optimal latency for your SAP data?',
        dimension: 'If you are analysing  your SAP data from a data warehouse or data lake, what is the optimal latency for your SAP data?',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },
    {
        questionId: 14,
        group: 'Unlocking SAP data for Analytics',
        question: 'Fresher, faster use of SAP data, would completely change the way that senior leaders are able to make decisions at my organisation',
        dimension: 'Fresher, faster use of SAP data, would completely change the way that senior leaders are able to make decisions at my organisation',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
    },
    {
        questionId: 15,
        group: 'Unlocking SAP data for Analytics',
        question: 'Does your group below need a lot of help in further utilising or unlocking your organisation’s SAP data?',
        dimensionStack: '=Left(Groups2, Len(Groups2)-1)',
        dimension: 'Group Answer2',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'stacked',
        sortBy: 'dimension',
        sortDir: 'asc',
    },
    {
        questionId: 16,
        group: 'Unlocking SAP data for Analytics',
        question: 'SAP data analytics has made my organisation more agile',
        dimension: 'SAP data analytics has made my organisation more agile',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
    },

    {
        questionId: 17,
        group: 'The economic benefits of unlocking SAP data',
        question: 'How much could you reduce expenses by leveraging your SAP data outside of SAP?',
        dimension: 'How much could you reduce expenses by leveraging your SAP data outside of SAP?',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        featured: true,
        sortBy: 'dimension',
        sortDir: 'desc',
    },
    {
        questionId: 18,
        group: 'The economic benefits of unlocking SAP data',
        question: 'How much could you increase revenue by leveraging your SAP data outside of SAP?',
        dimension: 'How much could you increase revenue by leveraging your SAP data outside of SAP?',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        featured: true,
        sortBy: 'dimension',
        sortDir: 'desc',
    },
    {
        questionId: 19,
        group: 'The economic benefits of unlocking SAP data',
        question: 'Unlocking the significant value of our SAP data should be a critical priority for my organisation this year',
        dimension: 'Unlocking the significant value of our SAP data should be a critical priority for my organisation this year',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },

    {
        questionId: 20,
        group: 'The economic benefits of unlocking SAP data',
        question: 'Would your group below get great value from further utilising or unlocking its SAP data?',
        dimensionStack: 'Groups',
        dimension: 'Group Answer',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'stacked',
        sortBy: 'dimension',
    },
    {
        questionId: 21,
        group: 'The economic benefits of unlocking SAP data',
        question: 'Replicating our SAP data into the cloud could be the catalyst for success that my organisation needs in 2023',
        dimension: 'Replicating our SAP data into the cloud could be the catalyst for success that my organisation needs in 2023',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },
    {
        questionId: 22,
        group: 'The economic benefits of unlocking SAP data',
        question: 'If you were able to improve your use of SAP data, how would you rank the following as a desired benefit (1 = most desirable)',
        dimensionStack: 'Rank',
        dimension: 'Rank Answer',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'stacked',
    },
    {
        questionId: 23,
        group: 'The economic benefits of unlocking SAP data',
        question: 'Our organisation has freedom to move our SAP data',
        dimension: 'Our organisation has freedom to move our SAP data',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },
    {
        questionId: 24,
        group: 'The economic benefits of unlocking SAP data',
        question: 'Budgets inhibit my organisation’s current use of SAP data',
        dimension: 'Budgets inhibit my organisation’s current use of SAP data',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },

    {
        questionId: 25,
        group: 'The economic benefits of unlocking SAP data',
        question: 'If we cannot realise the full value of our SAP data, then my organisation will become less competitive',
        dimension: 'If we cannot realise the full value of our SAP data, then my organisation will become less competitive',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },
    {
        questionId: 26,
        group: 'Integration Challenges',
        question: 'How easy or difficult is it to integrate SAP data together at your organisation',
        dimension: 'How easy or difficult is it to integrate SAP data together at your organisation',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },

    {
        questionId: 27,
        group: 'Integration Challenges',
        question: 'How easy or difficult is it to integrate IT data together at your organisation',
        dimension: 'How easy or difficult is it to integrate IT data together at your organisation',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },
    {
        questionId: 28,
        group: 'Integration Challenges',
        question: 'How easy or difficult is it to integrate Other internal data sets from applications together at your organisation',
        dimension: 'How easy or difficult is it to integrate Other internal data sets from applications together at your organisation',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },

    {
        questionId: 29,
        group: 'Integration Challenges',
        question: 'How easy or difficult is it to integrate External data from partners e.g., supply chain, distribution together at your organisation',
        dimension: 'How easy or difficult is it to integrate External data from partners e.g., supply chain, distribution together at your organisation',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },

    {
        questionId: 30,
        group: 'Integration Challenges',
        question: 'How easy or difficult is it to integrate Finance data together at your organisation',
        dimension: 'How easy or difficult is it to integrate Finance data together at your organisation',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },

    {
        questionId: 31,
        group: 'Integration Challenges',
        question: 'How easy or difficult is it to integrate operational technology data from machine systems e.g., sensor and/or shop floor together at your organisation',
        dimension: 'How easy or difficult is it to integrate operational technology data from machine systems e.g., sensor and/or shop floor together at your organisation',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'bar',
        sortBy: 'dimension',
    },

    {
        questionId: 32,
        group: 'Integration Challenges',
        question: "To what extent, if at all, have the following hindered your organisation's integration of its SAP ERP data?",
        dimensionStack: 'Hindered',
        dimension: 'Hindered Answer',
        measureLabel: '% of Respondents',
        measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
        measureAltLabel: 'Number of Respondents',
        measureAlt: 'Count(Distinct respid)',
        type: 'stacked',
        // sortBy: 'dimension',
        sortDir: 'desc',
        width: 'full',
    },

];

export default questionsData;
